<a
  class="edit-button"
  [ngClass]="{'edit-button--disabled' : disabled }"
  (click)="onClick()">
  <i class="icon-edit"></i>
</a>
